export default {
  root: {
    color: 'inherit',
  },
}
